import type { Permission } from "@lib/permissionConstants";

import { resolvePermission } from "@services/permissions/useResolvePermission/resolvePermission";

export const useResolvePermission = (): ((permission: Permission) => Permission) => {
  return resolvePermission;
};
